import React from 'react';
import { Link } from 'react-router-dom';

export interface BreadcrumbItem {
  label: string;
  to?: string;
}

export interface BreadcrumbsProps {
  items: BreadcrumbItem[];
  className?: string;
  /** Optional: render custom link (e.g. React Router Link). Default uses React Router Link with `to`. */
  renderLink?: (item: BreadcrumbItem, children: React.ReactNode) => React.ReactNode;
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({
  items,
  className = '',
  renderLink,
}) => {
  if (items.length === 0) return null;

  return (
    <nav aria-label="Breadcrumb" className={`text-sm ${className}`}>
      <ol className="flex flex-wrap items-center gap-x-2 gap-y-1 text-stone-500">
        {items.map((item, i) => {
          const isLast = i === items.length - 1;
          const linkContent = renderLink
            ? renderLink(item, <>{item.label}</>)
            : item.to != null ? (
                <Link to={item.to} className="hover:text-stone-900 transition-colors">
                  {item.label}
                </Link>
              ) : (
                <span>{item.label}</span>
              );
          return (
            <li key={i} className="flex items-center gap-x-2">
              {i > 0 && (
                <span className="text-stone-300 select-none" aria-hidden>
                  /
                </span>
              )}
              {isLast ? (
                <span className="text-stone-700 font-medium" aria-current="page">
                  {item.label}
                </span>
              ) : (
                linkContent
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
